import { Link, useRouterState } from '@tanstack/react-router'
import { PortfolioNav, buildPortfolioProducts, type PortfolioNavLink } from '@saas-pages/shared/public/app-shell'
import { resolveUtilitySourceToolKey } from '@saas-pages/shared/public/registry'
import { useT } from '@/shared/i18n'
import { ThemeSwitcher } from '@/shared/theme/theme'
import { buildUtilities } from '@/shared/utilities/utilities'
import { LangSwitcher } from '@/widgets/lang-switcher/LangSwitcher'

export function UmbrellaNav() {
  const t = useT()
  const utilities = buildUtilities(t)
  const pathname = useRouterState({ select: (state) => state.location.pathname })
  const navItems: PortfolioNavLink[] = [
    ...utilities.map((utility) => ({
      key: utility.key,
      label: utility.title,
      href: utility.path,
      disabled: utility.status === 'coming-soon',
    })),
    { key: 'blog', label: t.nav.blog, href: '/blog' },
  ]

  return (
    <PortfolioNav
      brandLabel="pdfy.ru"
      brandHref="/"
      products={buildPortfolioProducts('pdfy')}
      items={navItems}
      sourceToolKey={resolveUtilitySourceToolKey(utilities, pathname)}
      actions={(
        <>
          <ThemeSwitcher />
          <LangSwitcher />
        </>
      )}
      renderLink={(link, className, children) => (
        <Link
          to={link.href}
          className={className}
          activeProps={
            link.key === 'brand'
              ? undefined
              : { className: 'bg-accent text-foreground' }
          }
        >
          {children}
        </Link>
      )}
    />
  )
}
